import CartUtil from 'common/util/CartUtil';
import orderCart from './order-cart';
import orderForm from './order-form';
import orderDialog from './order-dialog'
import waErrorText from './wa-error-text'
import './styles/_order-page.scss';
import ModalUtil from 'common/util/ModalUtil';
import {node_observable_component} from 'common/util/ComponentDecorator';

orderForm();
orderCart();
waErrorText();
orderDialog();

@node_observable_component
export default class orderPage {
    static classname = 'order-page';
    #decorator = $();

    constructor($decorator) {
        this.#decorator = $decorator;
        this.initEventListeners();

    }

    initEventListeners() {
        this.#decorator.on('click', '.js-clear-cart', () => {
            if (window.delete_item_modal !== undefined) {
                const $deleteModal = $(window.delete_item_modal);
                $deleteModal.find('.order-page-delete__btn').on('click', () => {
                    ModalUtil.close();
                    this.clearCart();
                })
                ModalUtil.openContent($deleteModal);
            } else {
                ModalUtil.close();
                this.clearCart();
            }
        })

        this.#decorator.on('remove_product', () => {
            this.refresh();
        })
    }

    clearCart() {
        CartUtil.clear().then(() => this.refresh());
    }

    refresh() {
        $.ajax({url: ''}).then(res => {
            const $new_page = $(res).find('#js-order-page');
            this.#decorator.replaceWith($new_page);
            Update($new_page);
        })

    }
}